import { IOrgUnit } from '../../interfaces/orgunit/IOrgUnit';

export class LoadOrgUnits {
  static readonly type = '[OrgUnit] LoadOrgUnits';
}

export class UpdateOrgUnit {
  static readonly type = '[OrgUnit] UpdateOrgUnit';

  constructor(public orgUnit: IOrgUnit) {}
}

export class CreateOrgUnit {
  static readonly type = '[OrgUnit] CreateOrgUnit';

  constructor(public orgUnit: IOrgUnit) {}
}
